module.exports = __webpack_public_path__ + "img/symbol_1.2eccdd1f.png";